import * as React from 'react';

import {motion, AnimatePresence} from 'framer-motion';

import {getUserPrefersReducedMotion} from 'nutshell-core/utils/get-user-prefers-reduced-motion';

type Props = {
    children: React.ReactNode | null | undefined;
    // When this value changes, the animation will trigger
    triggerKey: string | number;
    initial?: {
        [key: string]: any;
    };
    animate?: {
        [key: string]: any;
    };
    exit?: {
        [key: string]: any;
    };
    transition?: {
        [key: string]: any;
    };
    exitBeforeEnter?: boolean;
};

export function KeyTriggeredAnimateIn(props: Props) {
    const {
        children,
        triggerKey,
        initial = {opacity: 0, y: 20},
        animate = {opacity: 1, y: 0},
        exit = {opacity: 0, y: -10},
        transition = {
            duration: 0.6,
            ease: 'easeInOut',
        },
        exitBeforeEnter = true,
    } = props;

    if (!children) {
        return null;
    }

    if (getUserPrefersReducedMotion()) {
        return children;
    }

    return (
        <AnimatePresence exitBeforeEnter={exitBeforeEnter}>
            <motion.div
                key={triggerKey}
                initial={initial}
                animate={animate}
                exit={exit}
                transition={transition}
            >
                {children}
            </motion.div>
        </AnimatePresence>
    );
}
